function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M404.3,315.4c-10-20.9-46-50-80.7-78.1c-19.4-15.7-37.7-30.5-49.3-42.1c-2.9-2.9-7.3-3.9-11.2-2.5 c-7.2,2.6-11.6,4.6-15.1,6.2c-5.3,2.4-7.1,3.2-14.3,3.9c-3.2,0.3-6,2-7.8,4.7c-15.1,22.5-30.7,20.6-41.1,17.1 c-3.3-1.1-3.9-2.5-4.2-3.9c-2.2-9.4,9-31.2,23.6-45.7c34.7-34.7,52.5-43.4,90.3-26.5c42.8,19.2,85.8,34.2,86.2,34.3 c5.6,1.9,11.6-1,13.6-6.6c1.9-5.6-1-11.6-6.6-13.6c-0.4-0.1-42.5-14.8-84.5-33.6c-48.9-21.9-75.8-7.5-114.1,30.9 c-14.6,14.6-34.4,44.1-29.3,65.8c2.2,9.2,8.7,16,18.3,19.2c24.2,8,46.2,0.3,62.7-21.5c6.8-1,10.5-2.6,16-5.1c2-0.9,4.4-1.9,7.5-3.2 c12.2,11.5,28.7,24.8,46,38.8c31.4,25.4,66.9,54.1,74.9,70.8c3.9,8.2-0.3,13.6-3.2,16c-4.2,3.6-10,4.8-13.1,2.6 c-3.5-2.4-8-2.5-11.5-0.4c-3.6,2.1-5.6,6.2-5.1,10.3c0.7,6.8-5.5,10.7-8.2,12c-6.8,3.5-14,2.9-16.6,0.4c-3-2.8-7.3-3.6-11.1-2.2 c-3.8,1.4-6.4,4.9-6.8,9c-0.6,7-5.8,13.7-12.6,16.3c-3.3,1.2-8,2-12.2-1.9c-2.6-2.4-6.3-3.3-9.7-2.5c-3.5,0.9-6.3,3.4-7.5,6.7 c-0.4,1.1-1.3,3.6-11.3,3.6c-7.1,0-19.9-4.8-26.1-8.9c-7.5-4.9-54.4-40-95-73.9c-5.7-4.8-15.6-15.1-24.3-24.2 c-7.7-8.1-14.8-15.4-18.4-18.5c-4.5-3.8-11.3-3.3-15,1.3c-3.8,4.5-3.2,11.2,1.3,15c3.3,2.8,9.7,9.6,16.8,16.9 c9.5,9.9,19.3,20.2,26,25.8c39.7,33.3,87.5,69.2,97,75.4c7.9,5.2,24.8,12.4,37.9,12.4c10.5,0,18.6-2.4,24.2-7.1 c7.5,2.9,16,2.9,24.3-0.3c9.7-3.8,17.7-11.3,22.2-20.5c8.4,1.8,18,0.5,26.8-3.9c8.6-4.3,14.7-10.9,17.8-18.6 c8.5,0.4,17.2-2.6,24.5-8.8C408,346.4,411.3,330.1,404.3,315.4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M213.3,138.7h-96c-5.9,0-10.7,4.8-10.7,10.7s4.8,10.7,10.7,10.7h96c5.9,0,10.7-4.8,10.7-10.7 S219.2,138.7,213.3,138.7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M435.5,292.7c-3.3-4.9-9.9-6.2-14.8-2.9l-31.2,20.9c-4.9,3.3-6.2,9.9-2.9,14.8c2.1,3.1,5.4,4.7,8.9,4.7 c2,0,4.1-0.6,5.9-1.8l31.2-20.9C437.5,304.2,438.8,297.6,435.5,292.7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M369.3,343.6c-7.6-6-41.8-41-62.9-63c-4.1-4.3-10.8-4.4-15.1-0.3c-4.3,4.1-4.4,10.8-0.3,15.1 c5.5,5.7,53.8,56.1,65.1,65c1.9,1.5,4.3,2.3,6.6,2.3c3.1,0,6.3-1.4,8.4-4.1C374.7,354,373.9,347.3,369.3,343.6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M326.7,365c-12.8-10.2-44.9-44.3-52.1-52.2c-4-4.4-10.7-4.6-15.1-0.6c-4.3,4-4.6,10.8-0.6,15.1 c0.4,0.4,38.7,41.8,54.5,54.4c2,1.6,4.3,2.3,6.7,2.3c3.1,0,6.2-1.4,8.3-4C332,375.4,331.3,368.7,326.7,365"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M284.2,386.5c-15.2-12.8-46.3-46-52.4-52.5c-4-4.3-10.8-4.5-15.1-0.5c-4.3,4-4.5,10.8-0.5,15.1 c8.7,9.4,38.5,40.9,54.3,54.2c2,1.7,4.4,2.5,6.9,2.5c3,0,6.1-1.3,8.2-3.8C289.3,397,288.7,390.3,284.2,386.5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M124.7,120.3C106.4,102.9,33.3,97.3,11.3,96c-3-0.1-5.8,0.9-8,2.9c-2.1,2-3.3,4.8-3.3,7.8v192 c0,5.9,4.8,10.7,10.7,10.7h64c4.6,0,8.7-3,10.1-7.4c1.6-4.8,38.3-117.6,43.2-173.1C128.2,125.7,127,122.5,124.7,120.3 M66.9,288 H21.3V118.1c34.3,2.7,71.3,8.6,84.7,15.1C100.4,179.9,74.8,263,66.9,288"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M501.3,117.3c-83.8,0-130.2,21.4-132.2,22.3c-2.8,1.3-4.8,3.7-5.7,6.6c-0.9,2.9-0.4,6.1,1.2,8.7 c13.2,21.2,54.5,139.1,62.4,167.9c1.3,4.6,5.5,7.8,10.3,7.8h64c5.9,0,10.7-4.8,10.7-10.7V128C512,122.1,507.2,117.3,501.3,117.3  M490.7,309.3h-45.4c-10.1-32.9-40-118.8-56.6-154.3c16.3-5.5,51.2-15,102-16.2V309.3z"
});

var SvgPvTransparencia = function SvgPvTransparencia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvTransparencia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-transparencia.45e5dfff.svg";
export { ForwardRef as ReactComponent };